import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environment/environment';


@Pipe({
  name: 'imageUrl'
})
export class ImageUrlPipe implements PipeTransform {
  transform(imagePath: string): string {
    if (!imagePath) return '';
    const cleanedPath = imagePath.replace(/\\/g, '/');
    return `${environment.imageUrl}${cleanedPath}`;
  }
}
